import { ChatModel } from '../../models/chat';

export enum ActionType {
  SET_CHATS = 'SET_CHATS',
  SET_CURRENT_CHAT = 'SET_CURRENT_CHAT',
  ADD_CHAT = 'ADD_CHAT',
  DELETE_CHAT = 'DELETE_CHAT',
  PATCH_CHAT = 'PATCH_CHAT',
  UNSHIFT_CURRENT_CHAT = 'UNSHIFT_CURRENT_CHAT',
}

interface SetChatsAction {
  type: ActionType.SET_CHATS;
  payload: ChatModel[];
}

interface SetCurrentChatAction {
  type: ActionType.SET_CURRENT_CHAT;
  payload?: string;
}

interface AddChatAction {
  type: ActionType.ADD_CHAT;
  payload: ChatModel;
}

interface DeleteChatAction {
  type: ActionType.DELETE_CHAT;
  payload: string;
}

interface PatchChatAction {
  type: ActionType.PATCH_CHAT;
  payload: ChatModel;
}

interface UnshiftCurrentChatAction {
  type: ActionType.UNSHIFT_CURRENT_CHAT;
}

export type ActionTypes =
  | SetChatsAction
  | SetCurrentChatAction
  | AddChatAction
  | DeleteChatAction
  | PatchChatAction
  | UnshiftCurrentChatAction;

export const setChats = (data:any): SetChatsAction => ({
  type: ActionType.SET_CHATS,
  payload: data,
});

export const setCurrentChat = (classId?: string): SetCurrentChatAction => ({
  type: ActionType.SET_CURRENT_CHAT,
  payload: classId
});

export const addChat = (newChat: ChatModel): AddChatAction => ({
  type: ActionType.ADD_CHAT,
  payload: newChat,
});

export const deleteChat = (classId: string): DeleteChatAction => ({
  type: ActionType.DELETE_CHAT,
  payload: classId,
});

export const patchChat = (updatedChat: ChatModel): PatchChatAction => ({
  type: ActionType.PATCH_CHAT,
  payload: updatedChat,
});

export const unshiftCurrentChat = (): UnshiftCurrentChatAction => ({
  type: ActionType.UNSHIFT_CURRENT_CHAT
});